var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllSetName(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 60,
    fill: "#F7F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.3214 58.1144C62.6968 58.1156 65.0191 57.4123 66.9946 56.0934C68.9702 54.7746 70.5102 52.8994 71.4198 50.7051C72.3294 48.5109 72.5678 46.0961 72.1047 43.7663C71.6417 41.4366 70.4981 39.2965 68.8185 37.6168C67.139 35.9371 64.999 34.7933 62.6692 34.3301C60.3395 33.8669 57.9247 34.1051 55.7304 35.0146C53.5361 35.924 51.6608 37.4639 50.3417 39.4393C49.0227 41.4147 48.3193 43.737 48.3203 46.1124C48.3248 49.294 49.5906 52.344 51.8403 54.5938C54.0899 56.8436 57.1398 58.1096 60.3214 58.1144Z",
    stroke: "#909090",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.964 68.0156H72.678C76.1162 68.0156 79.4137 69.3815 81.8449 71.8127C84.2762 74.2439 85.642 77.5414 85.642 80.9797V86.4156H35V80.9797C35 77.5414 36.3658 74.2439 38.7971 71.8127C41.2283 69.3815 44.5258 68.0156 47.964 68.0156Z",
    stroke: "#909090",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllSetName);
export default __webpack_public_path__ + "static/media/ill_set_name.6274f5d528e6463ef42031e138ca842f.svg";
export { ForwardRef as ReactComponent };